import axios from 'axios';
import {useQuery} from 'react-query';

export const useClientType = async () => {
    if (
        sessionStorage.getItem('client_typologie') === '' ||
        sessionStorage.getItem('client_typologie') === null
    ) {
        const params = {};
        const response = await axios.get('/api/customers/typologie', {params: params});
        sessionStorage.setItem('client_typologie', typeof response.data === 'string' ? response.data : '');
    }
    return sessionStorage.getItem('client_typologie');
};

const CLIENT_TYPE_QUERY_KEY = 'clientType';

export const useGetClientType = () =>
    useQuery<string | null, unknown, string | null>(
        CLIENT_TYPE_QUERY_KEY,
        async () => {
            const response = await axios.get('api/customers/typologie');
            return typeof response.data === 'string' ? response.data : null;
        },
        {staleTime: Infinity, cacheTime: Infinity}
    );
